import { api } from "@/constants"
import { getAuthHeader, serializeQueryParams } from "@/util"
import baseURL from "@/service/api"

const promo = {
  promos: (params) => {
    const url = api.promo.list + serializeQueryParams(params)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  createPromo: (payloads) => {
    const url = api.promo.create
    return baseURL.post(url, payloads, { headers: getAuthHeader() })
  },
  getPromoDetail: (id) => {
    const url = api.promo.detail(id)
    return baseURL.get(url, { headers: getAuthHeader() })
  },
  updatePromo: (id, payloads) => {
    const url = api.promo.detail(id)
    return baseURL.put(url, payloads, { headers: getAuthHeader() })
  },
  deletePromo: (id) => {
    const url = api.promo.detail(id)
    return baseURL.delete(url, { headers: getAuthHeader() })
  }
}

export default promo
